import { loadRuntimeConfig } from "./config/runtime";

/**
 * Load environment-specific runtime config from /config.json before
 * bootstrapping the React app. This allows the same build artifact to be
 * reused across local / staging / production without a rebuild.
 *
 * All modules that consume `getConfig()` (e.g. constant.ts) are imported
 * transitively through bootstrap.tsx, which is dynamically imported AFTER
 * the config fetch resolves — guaranteeing the config is always available
 * when those modules are first evaluated.
 */
loadRuntimeConfig().then(async () => {
	const { bootstrap } = await import("./bootstrap");
	bootstrap();
});
